import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { ItemProductsService } from '../../../../services/api/general-settings/item-products.service';
import { ItemProductsFormComponent } from '../components/item-products-form/item-products-form.component';

@Component({
  selector: 'app-item-products-edit-page',
  imports: [ItemProductsFormComponent],
  templateUrl: './item-products-edit-page.component.html',
  styleUrl: './item-products-edit-page.component.scss'
})
export class ItemProductsEditPageComponent {
  itemProductId!: number
  itemProduct?: any;

  constructor(
    private route: ActivatedRoute,
    private itemProductsService: ItemProductsService,
  ) {
  }

  ngOnInit(): void {
    this.itemProductId = Number(this.route.snapshot.paramMap.get('itemProductId'));
    if (this.itemProductId) {
      this.loadData(this.itemProductId);
    }
  }

  loadData(itemProductId: any) {
    this.itemProductsService.detail(itemProductId).subscribe((response: any) => {
      this.itemProduct = response.data?.itemProduct;
    });

  }
}
